import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import _ from "lodash";
import util from "./util";
import api from "./api";
import moment from "moment";
import "echarts-gl";
import "animate.css/animate.compat.css";
import "./style/main.css"; // 导入公用样式文件
import md5 from 'js-md5';
import {
  Button,
  DatePicker,
  Dialog,
  Image,
  Loading,
  Message,
  Option,
  Pagination,
  Select,
  Table,
  RadioGroup,
  RadioButton,
  TableColumn
} from "element-ui";
import "element-theme-dark";
import Mixin from "./mixin";

const ECharts = require("echarts");

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Dialog.name, Dialog);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Table.name, Table);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Pagination.name, Pagination);
Vue.component(Image.name, Image);

Vue.mixin(Mixin);

moment.locale("zh");

// 定义常用的全局配置
Vue.prototype.$api = api;
Vue.prototype.$util = util;
Vue.prototype.$echarts = ECharts;
Vue.prototype.$lodash = _;
Vue.prototype.$moment = moment;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading;
Vue.prototype.$md5= md5;


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
